module.exports = __webpack_public_path__ + "img/font-placeholder-img.ca5f8a5f.png";